<template>
  <b-form-input
    v-bind="$attrs"
    :value="value_formatted"
    @input="onInput"
    v-on="$listeners"
  />
</template>

<script>
export default {
  model: {
    event: 'input'
  },
  props: {
    value: [String, Number],
    format: {
      type: String,
      default() { return '0,0.[000]'; }
    },
    prefix: {
      type: String,
      default() { return undefined }
    }
  },
  data() {
    return {
      waitForDecimal: false,
      decimalPart: ''
    }
  },
  computed: {
    decimalSymbol() {
      return this.$numeral.locales[this.$i18n.locale].delimiters.decimal;
    },
    value_formatted() {
      return this.valueFormatter()
    }
  },
  watch: {
    value(value) {
      this.$emit('input', (value && this.$numeral(this.$numeral(value).format(this.format)).value()));
    }
  },
  methods: {
    valueFormatter() {
      if (this.value === '' || this.value === null || this.value === undefined) return this.value;
      return (this.prefix || '') + this.$numeral(this.value).format(this.format) + (this.waitForDecimal ? this.decimalPart : '');
    },
    onInput(event) {
      const value = event && event.target ? event.target.value : event;
      this.waitForDecimal = !!(value && value.includes(this.decimalSymbol) && !this.$numeral(value.split(this.decimalSymbol)[1] || 0).value());
      if (this.waitForDecimal) this.decimalPart = `${this.decimalSymbol}${(value || '').split(this.decimalSymbol)[1]}`;
      else this.decimalPart = '';
      this.$emit('input', (value && this.$numeral(this.$numeral(value).format(this.format)).value()));
    }
  }
}
</script>
